// extracted by mini-css-extract-plugin
export default {"editor":"RichTextEditor_editor__24OHY"};